import {
  TemplateListResponse,
  TemplateInfo,
  Template,
} from '../../../../create-surveys/layout/template-modal/template-modal.interface';
import { User } from '../../../interfaces/user.interface';

interface Deletable {
  check(): boolean;
}

export class TemplateDelationValidation implements Deletable {
  private readonly validations: Deletable[];

  constructor(
    template: Template | TemplateInfo,
    user: User | undefined,
    isWasp: boolean
  ) {
    this.validations = [
      new OwnerTemplate(template, user),
      new Concat([
        new UnSharedTemplate(template),
        new CommonTemplate(template),
        new WaspTemplate(template, isWasp),
      ]),
    ];
  }

  check(): boolean {
    const validation = this.validations.find((rule) => rule.check());
    return !!validation;
  }
}

export class FolderPermissions implements Deletable {
  private readonly validations: Deletable[];
  constructor(
    private readonly folder: TemplateListResponse,
    private readonly user: User | undefined,
    private readonly isWasp: boolean
  ) {
    this.validations = [
      new OwnerFolder(folder, user),
      new WaspFolder(folder, isWasp),
    ];
  }
  check(): boolean {
    const validation = this.validations.find((rule) => rule.check());
    return !!validation;
  }
}

class OwnerTemplate implements Deletable {
  constructor(
    private readonly template: Template | TemplateInfo,
    private readonly user: User | undefined
  ) {}

  check(): boolean {
    return Boolean(this.user && this.template.owner === this.user.cmp);
  }
}

class WaspTemplate implements Deletable {
  constructor(
    private readonly template: Template | TemplateInfo,
    private readonly isWasp: boolean
  ) {}

  check(): boolean {
    return Boolean(this.template.is_service_buyer && this.isWasp);
  }
}

class UnSharedTemplate implements Deletable {
  constructor(private readonly template: Template | TemplateInfo) {}

  check(): boolean {
    return Boolean(this.template.shared_with.length > 0);
  }
}

class CommonTemplate implements Deletable {
  constructor(private readonly template: Template | TemplateInfo) {}

  check(): boolean {
    return !this.template.is_default;
  }
}

class Concat implements Deletable {
  constructor(private readonly rules: Deletable[]) {}

  check(): boolean {
    return this.rules.every((rule) => rule.check());
  }
}

class OwnerFolder implements Deletable {
  constructor(
    private readonly folder: TemplateListResponse,
    private readonly user: User | undefined
  ) {}

  check(): boolean {
    return Boolean(this.user && this.folder.owner === this.user.cmp);
  }
}

class WaspFolder implements Deletable {
  constructor(
    private readonly folder: TemplateListResponse,
    private readonly isWasp: boolean
  ) {}

  check(): boolean {
    return Boolean(this.folder.is_service_buyer && this.isWasp);
  }
}
